import { render, staticRenderFns } from "./Importexcel.vue?vue&type=template&id=28be2ca5"
import script from "./Importexcel.vue?vue&type=script&lang=js"
export * from "./Importexcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports